export const DRAFT_HEADER = "x-storyblok-draft";
export const DRAFT_PREFIX = "/draft-preview";
